<template>
  <div
  class="d-flex justify-center">
    <!-- NOTE: the value /1/ serves for badge to shows up -->
    <v-badge
    color="red"
    :dot="!isEmpty"
    :value="!isEmpty ? 1 : 0"
    overlap>
      <icon-button
      @click="$emit('click')"
      src="comment-processing"
      color="amber"
      :disabled="disableOnEmpty && isEmpty"/>
    </v-badge>
  </div>
</template>

<script>
import IconButton from '@/components/btns/IconButton'
export default {
  components: {
    IconButton
  },
  props: {
    value: {
      type: String,
      default: null
    },
    disableOnEmpty: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEmpty() {
      return this.value === null || this.value === undefined || this.value.length === 0
    }
  }
}
</script>

<style>

</style>